module.exports = __webpack_public_path__ + "cad9a393ae0bb2da7a5c2679ca2832ec.png";